import { gql } from '@apollo/client';
import { snakeCase } from 'lodash';
import type { FileType } from '@/types';
import type { Schema } from '../edit/schema';

export const CREATE_REGULAR_HEALTH_CHECKUP_RESULT = gql`
  mutation createRegularHealthCheckupResult($input: CreateRegularHealthCheckupResultInput!) {
    createRegularHealthCheckupResult(input: $input) {
      regularHealthCheckupResult {
        id
      }
    }
  }
`;

export interface CreateRegularHealthCheckupResultQueryVariables {
  input: {
    personalId: string;
    attributes: {
      officeId?: string | null;
      healthCheckupInstitutionId?: string | null;
      dateOn: string;
      orderByDoctor?: boolean | null;
      report?: File | FileType | null;
      specifiedWorkCode?: string | null;
      items: {
        itemCode: string;
        checked?: boolean | null;
        value?: string | null;
        evaluation?: string | null;
        hasFinding?: boolean | null;
      }[];
    };
  };
}

export interface CreateRegularHealthCheckupResultQueryResult {
  createRegularHealthCheckupResult: {
    regularHealthCheckupResult: {
      id: string;
    };
  };
}

export const convertFormDataToQueryVariables = (
  data: Schema,
  personalId: string
): CreateRegularHealthCheckupResultQueryVariables => {
  return {
    input: {
      personalId,
      attributes: {
        officeId: data.officeId,
        healthCheckupInstitutionId: data.healthCheckupInstitutionId,
        dateOn: data.dateOn,
        orderByDoctor: data.orderByDoctor === 'true',
        report: data.report,
        specifiedWorkCode: data.specifiedWorkCode[0],
        items: Object.entries(data.items).map(([itemCode, item]) => ({
          itemCode: snakeCase(itemCode).replace('_hz', 'hz'),
          checked: item.checked === 'true',
          value: item.value,
          evaluation: item.evaluation,
          hasFinding: item.hasFinding === 'true'
        }))
      }
    }
  };
};
